// Links por defecto (editálos aquí una sola vez)

import './SocialBar.css';
const DEFAULT_LINKS = {
  facebook: "https://www.facebook.com/facach",
  instagram: "https://www.instagram.com/facachhn/",
  youtube: "https://www.youtube.com/@facachfacach",
  x: "https://x.com/Facachhn",
  linkedin: "https://www.linkedin.com/company/facach/posts/?feedView=all",
  tiktok: "https://www.tiktok.com/@tu_usuario",
};


const SocialBar = ({
  links,                 // opcional: para sobrescribir alguno(s)
  position = "right",    // "right" | "left"
  top = "30%",           // acepta "50%" o "100px", etc.
  size = 42,             // tamaño de cada botón (px)
  rounded = true,        // true = bordes redondeados del bloque
  ariaLabel = "Redes sociales",
}) => {
  const merged = { ...DEFAULT_LINKS, ...(links || {}) };

  return (
    <nav
      className={`social-bar social-bar--${position} ${rounded ? "social-bar--rounded" : ""}`}
      style={{ top }}
      aria-label={ariaLabel}
    >
      {/* Facebook */}
      <a
        href={merged.facebook}
        className="social-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        title="Facebook"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.35C0 23.407.593 24 1.325 24h11.49v-9.294H9.847V11.01h2.968V8.41c0-2.94 1.794-4.542 4.416-4.542 1.254 0 2.33.093 2.644.135v3.064h-1.816c-1.426 0-1.702.678-1.702 1.67v2.273h3.404l-.444 3.696h-2.96V24h5.805C23.407 24 24 23.407 24 22.675V1.325C24 .593 23.407 0 22.675 0z"/>
        </svg>
      </a>

      {/* X */}
      <a
        href={merged.x}
        className="social-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="X"
        title="X"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18.244 2H21l-6.352 7.259L22.5 22h-6.66l-5.206-6.79L4.6 22H2l6.8-7.772L1.5 2h6.78l4.76 6.176L18.244 2zm-2.331 18h2.002L8.18 4H6.106l9.807 16z"/>
        </svg>
      </a>

      {/* YouTube */}
      <a
        href={merged.youtube}
        className="social-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube"
        title="YouTube"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M23.5 6.186a3.002 3.002 0 0 0-2.113-2.126C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.387.56A3.002 3.002 0 0 0 .5 6.186C0 7.98 0 12 0 12s0 4.02.5 5.814a3.002 3.002 0 0 0 2.113 2.126C4.4 20.5 12 20.5 12 20.5s7.6 0 9.387-.56A3.002 3.002 0 0 0 23.5 17.814C24 16.02 24 12 24 12s0-4.02-.5-5.814zM9.75 15.568V8.432L15.818 12 9.75 15.568z"/>
        </svg>
      </a>

      {/* Instagram */}
      <a
        href={merged.instagram}
        className="social-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        title="Instagram"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.24 2.427.403.61.224 1.047.492 1.507.952.46.46.728.897.952 1.507.163.457.347 1.257.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.97-.403 2.427a3.93 3.93 0 0 1-.952 1.507 3.93 3.93 0 0 1-1.507.952c-.457.163-1.257.347-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.24-2.427-.403a3.93 3.93 0 0 1-1.507-.952 3.93 3.93 0 0 1-.952-1.507c-.163-.457-.347-1.257-.403-2.427C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.056-1.17.24-1.97.403-2.427.224-.61.492-1.047.952-1.507.46-.46.897-.728 1.507-.952.457-.163 1.257-.347 2.427-.403C8.416 2.175 8.796 2.163 12 2.163zm0 1.622c-3.162 0-3.532.012-4.777.069-.98.045-1.51.208-1.862.345-.469.182-.803.4-1.155.752-.352.352-.57.686-.752 1.155-.137.352-.3.882-.345 1.862-.057 1.245-.069 1.615-.069 4.777s.012 3.532.069 4.777c.045.98.208 1.51.345 1.862.182.469.4.803.752 1.155.352.352.686.57 1.155.752.352.137.882.3 1.862.345 1.245.057 1.615.069 4.777.069s3.532-.012 4.777-.069c.98-.045 1.51-.208 1.862-.345.469-.182.803-.4 1.155-.752.352-.352.57-.686.752-1.155.137-.352.3-.882.345-1.862.057-1.245.069-1.615.069-4.777s-.012-3.532-.069-4.777c-.045-.98-.208-1.51-.345-1.862-.182-.469-.4-.803-.752-1.155a2.76 2.76 0 0 0-1.155-.752c-.352-.137-.882-.3-1.862-.345-1.245-.057-1.615-.069-4.777-.069zm0 3.351A4.864 4.864 0 1 1 7.136 12 4.864 4.864 0 0 1 12 7.136zm0 8.106A3.242 3.242 0 1 0 8.758 12 3.242 3.242 0 0 0 12 15.242zM17.339 6.62a1.134 1.134 0 1 1-1.134-1.134 1.134 1.134 0 0 1 1.134 1.134z"/>
        </svg>
      </a>

      {/* LinkedIn */}
      <a
        href={merged.linkedin}
        className="social-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
        title="LinkedIn"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.329-.027-3.037-1.852-3.037-1.853 0-2.136 1.447-2.136 2.943v5.663H9.351V9h3.414v1.561h.049c.476-.899 1.637-1.852 3.367-1.852 3.6 0 4.267 2.37 4.267 5.452v6.291zM5.337 7.433a2.064 2.064 0 1 1 0-4.128 2.064 2.064 0 0 1 0 4.128zM3.56 20.452h3.554V9H3.56v11.452z"/>
        </svg>
      </a>

      {/* TikTok */}
      <a
        href={merged.tiktok}
        className="social-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        title="TikTok"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21 8.17a6.9 6.9 0 0 1-4.37-1.53v7.11a6.55 6.55 0 1 1-6.55-6.56c.26 0 .52.02.77.06v3.51a3.07 3.07 0 1 0 2.17 2.94V2.5h3.46a6.9 6.9 0 0 0 4.52 4.2V8.17z"/>
        </svg>
      </a>
    </nav>
  );
};

export default SocialBar;